module.exports = __webpack_public_path__ + "img/relogio.53dfa7ea.svg";